import { useGetList } from 'react-admin';
import { Position } from 'src/models';

import { AccountPositionList } from './AccountPositionList';

export interface TradableUserPositionsListProps {
  accountId: number;
}

export const AccountTradablePositionsList = ({ accountId }: TradableUserPositionsListProps) => {
  const { data, isLoading } = useGetList<Position>('orders.positions', {
    meta: {
      accountId,
    },
  });

  const tradablePositions = data?.filter(aPosition => aPosition.isTradable);
  const labels = {
    value: 'Last Price',
    totalValue: 'Current Value',
  };

  return <AccountPositionList items={tradablePositions ?? []} isLoading={isLoading} labels={labels} />;
};
